import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=1f99aab8"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"
import style0 from "./Badge.vue?vue&type=style&index=0&id=1f99aab8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports